import { Tab as MuiTab, tabClasses as muiTabClasses } from '@mui/material';
export const Tab = MuiTab;
export const tabClasses = muiTabClasses;
